<div class="summary">
  <div class="summary__widget">
    <h2 class="summary__widget__title" i18n>Overview</h2>
    <div class="summary__widget__content">
      <ub-grid template="repeat(4, 1fr)">
        <ub-label *ngIf="bookingItemOption.venue" label="Venue" display="column" i18n-label>
          <span text>{{ bookingItemOption.venue?.name}}</span>
        </ub-label>
        <ub-label *ngIf="bookingItemOption.summary.price.min !== null" label="Price" display="column" i18n-label>
          <span text>{{ bookingItemOption.summary.price| easPriceRange: bookingCurrency }}</span>
        </ub-label>
        <ub-label *ngIf="options?.showCapacityInfo && bookingItemOption.summary.openOptions" label="Status" text="OPEN" variant="success" display="column" i18n-label i18n-text></ub-label>
        <ub-label *ngIf="options?.showCapacityInfo && !bookingItemOption.summary.openOptions" label="Status" text="CLOSED" variant="warn" display="column" i18n-label i18n-text></ub-label>
        <ub-label *ngIf="bookingItemOption.summary.bookingWindow?.min" label="Booking window" display="column" i18n-label>
          <span text>{{ bookingItemOption.summary.bookingWindow | easDateRange: timezone: bookingItemOption.bookingWindow?.timezone }}</span>
        </ub-label>
      </ub-grid>
    </div>
    <div class="summary__widget__footer" *ngIf="options?.showCapacityInfo">
      <span *ngIf="bookingItemOption.summary.openOptions" i18n>This booking contains <strong>{{ bookingItemOption.summary.openOptions }} open bookable options</strong></span>
      <span *ngIf="!bookingItemOption.summary.openOptions" i18n>This booking is closed</span>
    </div>
  </div>

  <div class="summary__widget">
    <h2 class="summary__widget__title" i18n>Income</h2>
    <div class="summary__widget__content">
      <div class="summary__widget__amounts">
        <p class="summary__widget__amount--large">{{ bookingItemOption.stats?.summary.receivedReal ?? 0 | currency: bookingCurrency }}</p>
        <p class="summary__widget__amount__label summary__widget__label--warn">
          <span class="summary__widget__amount">{{ bookingItemOption.stats?.summary.receivedPending ?? 0 | currency: bookingCurrency }}</span> <span class="upper" i18n>pending</span>
        </p>
      </div>
    </div>
    <div class="summary__widget__footer">
      <span i18n>Income to date from payments before refunds</span>
    </div>
  </div>

  <div class="summary__widget">
    <h2 class="summary__widget__title" i18n>Balance</h2>
    <div class="summary__widget__content">
      <div class="summary__widget__amounts">
        <p class="summary__widget__amount--large">{{ this.bookingItemOption.stats?.summary.balanceReal ?? 0 | currency: bookingCurrency }}</p>
        <p class="summary__widget__amount__label summary__widget__label--warn">
          <span class="summary__widget__amount">{{ bookingItemOption.stats?.summary.balancePending ?? 0 | currency: bookingCurrency }}</span> <span class="upper" i18n>pending</span>
        </p>
      </div>
    </div>
    <div class="summary__widget__footer">
      <span i18n>Balance to date from payments after refunds</span>
    </div>
  </div>

  <div class="summary__widget">
    <h2 class="summary__widget__title" i18n>Refunds</h2>
    <div class="summary__widget__content">
      <div class="summary__widget__amounts">
        <p class="summary__widget__amount--large">{{ refundsToDatePercentage }}%</p>
        <ub-label variant="success" label="COMPLETED" display="column" i18n-label>
          <span text>{{ bookingItemOption.stats?.summary.refundedReal ?? 0 | currency: bookingCurrency }}</span>
        </ub-label>
        <ub-label variant="warn" label="PENDING" display="column" i18n-label>
          <span text>{{ bookingItemOption.stats?.summary.refundedPending ?? 0 | currency: bookingCurrency }}</span>
        </ub-label>
      </div>
    </div>
    <div class="summary__widget__footer">
      <span i18n>Percentage of income refunded</span>
    </div>
  </div>
</div>
